const PERMISSION_KEY= "personalize:nebula_management_fees";
const PAGE_URL = {
    NEBULA_MANAGEMENT_FEE_PAGE: "/admin/personalize/nebula-management-fee"
}

export {PERMISSION_KEY, PAGE_URL}

